var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotIsTypingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160850",
    "data-name": "Group 160850",
    transform: "translate(-862 -482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160829",
    "data-name": "Group 160829",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_249",
    "data-name": "Ellipse 249",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(860 481)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_bot_24_regular",
    transform: "translate(864.631 484.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_-Color",
    "data-name": "\\uD83C\\uDFA8-Color",
    d: "M10.653,7.8a1.088,1.088,0,0,1,1.088,1.088v.438a1.814,1.814,0,0,1-.632,1.376,4.834,4.834,0,0,1-3.238.968,4.827,4.827,0,0,1-3.236-.967A1.814,1.814,0,0,1,4,9.33V8.892A1.088,1.088,0,0,1,5.092,7.8Zm0,.725H5.092a.363.363,0,0,0-.363.363V9.33a1.088,1.088,0,0,0,.379.825,4.144,4.144,0,0,0,2.763.792,4.151,4.151,0,0,0,2.766-.793,1.088,1.088,0,0,0,.379-.826V8.892A.363.363,0,0,0,10.653,8.529ZM7.822,2l.049,0a.363.363,0,0,1,.359.313l0,.049v.362H9.926a1.088,1.088,0,0,1,1.088,1.088V5.992A1.088,1.088,0,0,1,9.926,7.08H5.815A1.088,1.088,0,0,1,4.727,5.992V3.814A1.088,1.088,0,0,1,5.815,2.726H7.508V2.363A.363.363,0,0,1,7.822,2l.049,0Zm2.1,1.447H5.815a.363.363,0,0,0-.363.363V5.992a.363.363,0,0,0,.363.363H9.926a.363.363,0,0,0,.363-.363V3.814A.363.363,0,0,0,9.926,3.451Zm-3.144.725a.6.6,0,1,1-.6.6A.6.6,0,0,1,6.782,4.176Zm2.173,0a.6.6,0,1,1-.6.6A.6.6,0,0,1,8.955,4.176Z",
    transform: "translate(-4.004 -2)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotIsTypingIcon);
export default __webpack_public_path__ + "static/media/bot-isTyping-icon.e465a5b9a9d08273f091b19ec7030611.svg";
export { ForwardRef as ReactComponent };